#import "~/graphql/fragments/categories/subsidyCategoryContent.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

query getSubsidyCategory ($group: [String!], $site: [String!], $slug: [String], $uri: [String], $level: Int) {
    category(
        site: $site
        group: $group
        uri: $uri
        slug: $slug
        level: $level
    ) {
        ... subsidyCategoryContent
        children {
            ... subsidyCategoryContent
        }

        ... on subsidyCategory_Category {
            showNewsletterSubscribe
            seo {
                ... socialFragment
            }
        }
    }
}
